<template>
  <div class="container-fluid">
    <div class="row">
      <h3 class="m-4">Please initial the following to indicate that you understand and agree.</h3>
    </div>

    <attestations-form-item
      v-for="attestation in attestations"
      :key="attestation.id"
      :attestation="attestation"
      :initials="initials"
      v-model="valuesMap[attestation.id]"
    />
  </div>
</template>

<script>
import AttestationsFormItem from './AttestationsFormItem.vue';

export default {
  name: 'attestations-form',
  components: {AttestationsFormItem},
  props: {
    attestations: {
      type: Array,
      required: true,
    },
    user: {
      type: Object,
    },
  },
  data() {
    return {
      valuesMap: {},
    };
  },
  computed: {
    formValid() {
      return !this.initials || this.attestations.every(({id}) => this.valuesMap[id]?.toUpperCase() === this.initials);
    },
    initials() {
      if (!this.user) {
        return '';
      }

      const firstName = this.user.first_name || '';
      const lastName = this.user.last_name || '';
      return String(firstName.slice(0, 1) + lastName.slice(0, 1)).toUpperCase();
    },
  },
  watch: {
    formValid: {
      handler(valid) {
        this.$emit('validity-change', valid);
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
